import React from 'react'
import { connect } from 'react-redux'
import c from 'classnames'
import isEmpty from 'lodash/isEmpty'
import Button from 'discada/dist/Button'
import debounce from 'lodash/debounce'

import Meta from 'components/VRP/Meta'

import { scrollTo } from 'utils'

import { getEntity } from 'selectors/entitySelectors'
import { getActiveHash } from 'selectors/pageStateSelectors'
import { getQuoteId, getQuoteDirty } from 'selectors/quoteSelectors'
import { VRP_SECTIONS } from '.'
import { getWritePermission } from 'selectors/authSelectors'

import './Header.scss'

export function Jumper({ currentSection, selectSection, scrollContainer }) {
  return (
    <span className="select jumper is-small">
      <select
        onChange={e => {
          scrollTo(e.target.value, scrollContainer, 50)
          selectSection(e.target.value)
        }}
        value={currentSection}
      >
        {Object.keys(VRP_SECTIONS).map(s => (
          <option key={s} value={s}>
            {VRP_SECTIONS[s]}
          </option>
        ))}
      </select>
    </span>
  )
}

export class Header extends React.Component {
  constructor(...args) {
    super(...args)

    this.state = { currentSection: '', dirty: this.props.dirty }

    this.selectSection = currentSection => this.setState({ currentSection })

    this.checkSection = debounce(() => {
      let scrollContainer = document.querySelector(this.props.scrollContainer),
        scrollContainerTop = scrollContainer ? scrollContainer.scrollTop : 0,
        currentSection = Object.keys(VRP_SECTIONS).find(
          s =>
            document.querySelector(`#${s}`) &&
            scrollContainerTop < document.querySelector(`#${s}`).offsetTop,
        )

      this.selectSection(currentSection)
    }, 500)
  }

  static getDerivedStateFromProps(newProps, oldState) {
    return { ...oldState, dirty: newProps.dirty }
  }

  render() {
    let { id, className, vehicle, isFixed, showBack } = this.props

    if (isEmpty(vehicle)) return null

    return (
      <div className={c('vrp-header', className, { 'is-fixed': isFixed })}>
        <div className="vrp-header-inner">
          <div className="vrp-header-info">
            <span className="vrp-header-info-vehicle">
              <span className="vehicle-name">
                {vehicle.year} <span>{vehicle.make}</span> {vehicle.model}{' '}
                {vehicle.trim}
              </span>
            </span>

            <Meta id={id} showVin />
          </div>

          {showBack && (
            <div className="back-wrapper">
              <Button
                size="small"
                reverse
                icon="chevron-right"
                onClick={this.props.onClose}
              >
                All Inventory
              </Button>
            </div>
          )}
        </div>
      </div>
    )
  }
}

function mapStateToProps(state, op) {
  let mode = getActiveHash(state),
    quoteId = getQuoteId(state, op.id),
    dirty = getQuoteDirty(state, op.id, quoteId)

  return {
    ...op,
    mode,
    quoteId,
    dirty,
    vehicle: getEntity(state, op.id),
    isManager: getWritePermission(state, 'deal.fields/profit'),
  }
}

export default connect(mapStateToProps)(Header)
